import React from "react";
import useProgramsQueries from "../../hooks/useProgramQueriesHigher";
import {
  IIntakeWizardConfigs,
  IWizardConfig,
  WizardMode,
  SubmitButtonColor,
} from "../../../wizard/types";
import deactivateFormValidator from "../validators/deactivateFormValidator";
import DeactivateContent from "../../../../components/DeactivateContent/DeactivateContent";
import DeleteContent from "../../components/DeleteContent";
import { getDeleteButtonConfigs } from "../../helpers/helperFunctions";
import { ENTITY_NAMES } from "../../../../constants";

async function getAppCount(fetch, id) {
  const { data } = await fetch({ intakeId: id });

  return {
    injectedData: {
      approved: data.approved,
      pending: data.pending,
    },
  };
}

export function useIntakeConfigHigher(): IIntakeWizardConfigs {
  const { activateIntake, deactivateIntake, fetchAppCount, deleteOneIntake } =
    useProgramsQueries();

  const getActivateConfig = (id): IWizardConfig => ({
    steps: [
      {
        titleConfig: {
          titleText: "Activate intake",
        },
        content: "Are you sure you want to activate this intake?",
      },
    ],
    submitButtonText: "Activate",
    cancelButtonText: "Close",
    saveCallback: () => activateIntake(id),
  });

  const getDeactivateConfig = (id): IWizardConfig => ({
    steps: [
      {
        titleConfig: {
          titleText: "Deactivate intake",
        },
        width: "552px",
        content: () => <DeactivateContent name={ENTITY_NAMES.intake} />,
        validator: deactivateFormValidator,
      },
    ],
    submitButtonText: "Deactivate",
    submitButtonColor: SubmitButtonColor.Danger,
    cancelButtonText: "Close",
    saveCallback: (data) =>
      deactivateIntake(id, {
        text: data?.reason ?? "",
      }),
    getInitialData: () => getAppCount(fetchAppCount, id),
  });

  const getDeleteIntakeConfig = (id): IWizardConfig => ({
    steps: [
      {
        width: "430px",
        titleConfig: {
          titleText: "Delete intake",
        },
        content: () => <DeleteContent name={ENTITY_NAMES.intake} />,
      },
    ],
    mode: WizardMode.Delete,
    getInitialData: () => getAppCount(fetchAppCount, id),
    saveCallback: () => deleteOneIntake(id),
    getButtonConfigs: getDeleteButtonConfigs,
  });

  return {
    getActivateConfig,
    getDeactivateConfig,
    getDeleteIntakeConfig,
  };
}
